import { Spacer, Flex, Stack } from '@backyard-ui/core';

import { type Review as ReviewType } from '@/infra/services/catalog/review/model';

import * as Review from '../../Review';

interface ItemProps {
  review: ReviewType;
}

function Item(props: ItemProps) {
  const {
    review: {
      id,
      date,
      text,
      author,
      rating,
      title,
      photos,
      videos,
      isRecommended,
      goodFeedbackAmount,
      badFeedbackAmount,
    },
  } = props;

  return (
    <Flex direction="column" align="flex-start">
      <Review.Head author={author} date={date} rating={rating} />
      <Spacer size="3.5" axis="vertical" />
      <Review.Title>{title}</Review.Title>
      <Spacer size="2" axis="vertical" />
      <Review.Description>{text}</Review.Description>
      <Spacer size="6" axis="vertical" />
      <Review.Recommendation isRecommended={isRecommended} />
      <Stack spacing="8" direction="column">
        <Review.Medias videos={videos} photos={photos} title={title} />
        <Review.Actions
          badFeedbackAmount={badFeedbackAmount}
          goodFeedbackAmount={goodFeedbackAmount}
          reviewId={id}
        />
      </Stack>
    </Flex>
  );
}

export default Item;
